import { toastr } from 'react-redux-toastr';
import {
  TOTALPOS_SALE,
  TOTALPOS_VOID,
  generatePinPadTransactionReprintEndpoint,
} from '../../config/endpoints';
import { DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { FLAG_TOTAL_POS_ACTIVITY } from '../types';
import {
  generatePinpadSaleId,
  recordPinpadEvent,
} from '../../utils/pinpadBlackBox';

const flagTotalPosSale = (flag) => (dispatch) => {
  dispatch({
    type: FLAG_TOTAL_POS_ACTIVITY,
    payload: flag,
  });
};

// raw agent request/response for the black box; void buttons outside the
// payment form have no sale id, so each call gets its own
const createAgentLogger = (blackBoxSaleId) => {
  const saleId = blackBoxSaleId || generatePinpadSaleId();
  return (type, detail) =>
    recordPinpadEvent({ saleId, form: 'TOTALPOS', type, detail });
};

const postTotalPosSale =
  ({ amount, operator, qrPayment, blackBoxSaleId }) =>
  async (dispatch) => {
    const logAgentEvent = createAgentLogger(blackBoxSaleId);
    try {
      dispatch(flagTotalPosSale(true));
      const url = TOTALPOS_SALE;
      const body = JSON.stringify({
        amount,
        operator,
        qrPayment: Boolean(qrPayment),
      });
      logAgentEvent('SALE_REQUEST', body);
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body,
      });
      const responseText = await response.text();
      logAgentEvent('SALE_HTTP', `status=${response.status} ${responseText}`);
      if (!response.ok) {
        toastr.error('Error', 'El agente pinpad respondió con un error.');
        return null;
      }
      const data = JSON.parse(responseText);
      if (data.approved) {
        toastr.success('Correcto', 'Cobro realizado correctamente.');
      } else {
        toastr.warning(
          'Advertencia',
          data.errorMessage || data.legend || 'No se pudo realizar el cobro.',
        );
      }
      return data;
    } catch (error) {
      logAgentEvent('SALE_FETCH_ERROR', error ? error.message : '');
      toastr.error(
        'Sin comunicación',
        'No se pudo comunicar con el POS. Verifique en el PinPad si la operación se completó antes de reintentar.',
      );
      return null;
    } finally {
      dispatch(flagTotalPosSale(false));
    }
  };

const postTotalPosVoid =
  ({ financialReference, operator, amount, qrPayment, blackBoxSaleId }) =>
  async (dispatch) => {
    const logAgentEvent = createAgentLogger(blackBoxSaleId);
    try {
      dispatch(flagTotalPosSale(true));
      const url = TOTALPOS_VOID;
      const body = JSON.stringify({
        financialReference,
        operator,
        amount,
        qrPayment: Boolean(qrPayment),
      });
      logAgentEvent('VOID_REQUEST', body);
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body,
      });
      const responseText = await response.text();
      logAgentEvent('VOID_HTTP', `status=${response.status} ${responseText}`);
      const data = JSON.parse(responseText);
      if (data.approved) {
        toastr.success('Correcto', 'Anulación realizada correctamente.');
      } else {
        toastr.warning(
          'Advertencia',
          data.errorMessage ||
            data.legend ||
            'No se pudo realizar la anulación.',
        );
        return null;
      }
      return data;
    } catch (error) {
      logAgentEvent('VOID_FETCH_ERROR', error ? error.message : '');
      toastr.error('Failed to complete void.');
      return null;
    } finally {
      dispatch(flagTotalPosSale(false));
    }
  };

const getPinPadTransactionsForReprint =
  ({ sourceType, sourceId }) =>
  async (dispatch) => {
    try {
      const url = generatePinPadTransactionReprintEndpoint({
        sourceType,
        sourceId,
      });
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      return await response.json();
    } catch (error) {
      toastr.error('Error', error.message);
      return null;
    }
  };

export { postTotalPosSale, postTotalPosVoid, getPinPadTransactionsForReprint };
